var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-button',{staticClass:"pb-1",attrs:{"label":"iOSでエラーになる場合","href":"https://kb.fairgrit.com/kb/ios-fileupload","icon":"fas fa-external-link-alt","small":"","open-link-in-new-tab":""}})}
var staticRenderFns = []

export { render, staticRenderFns }